import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles({ name: 'RadioGroup' })((theme) => ({
  container: {
    width: '100%',
  },
  legend: {
    // FormLabel as legend styling
    marginBottom: '4px',
    fontSize: '0.875rem',
    fontWeight: theme.typography.fontWeightBold,
    color: theme.palette.text.primary,
  },
}));

export default useStyles;
